import { useHistory } from 'react-router-dom';
import { DASHBOARD_RESOURCES } from 'constant';
import { URL } from '../../../helper';

const useList = () => {
	const history = useHistory();

	const redirectToUpdatePriorityList = (): void => {
		history.push(`${URL[DASHBOARD_RESOURCES.cashbackUtil]}/updatePriorityList`);
	};

	return {
		redirectToUpdatePriorityList
	};
};

export default useList;
